import Request from "lib/request";

export const login = (data) => {
  return Request({
    url: "login",
    method: "post",
    data,
  });
};
export const logout = () => {
  return Request({
    url: "logout",
    method: "get"
  });
};
export const register = (data) => {
  return Request({
    url: "register",
    method: "post",
    data,
  });
};
export const recover = (data)=>{
  return Request({
    url: "recover",
    method: "post",
    data
  });
}
export const changePassword = (data)=>{
  return Request({
    url: "change-password",
    method: "post",
    data
  });
}
export const verify = (data) => {
  return Request({
    url: "phone-verify",
    method: "post",
    data,
  });
};
export const profile = () => {
  return Request({
    url: "me",
    method: "get",
  });
};
export const updateProfile = (data) => {
  return Request({
    url: "profile",
    method: "put",
    data
  });
};
